module.exports = __webpack_public_path__ + "static/media/JUU.973fc28e.mp3";